"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.create = exports.getSectionAt = exports.getAt = exports.isInRange = exports.isSectionInRange = exports.sectionSize = void 0;
exports.sectionSize = 11;
var isSectionInRange = function (obj, secx, secy) {
    return (secx >= 0 &&
        secx < obj.sectionsWidth &&
        secy >= 0 &&
        secy < obj.sectionsHeight);
};
exports.isSectionInRange = isSectionInRange;
var isInRange = function (obj, x, y) {
    return x >= 0 && x < obj.totalTileWidth && y >= 0 && y < obj.totalTileHeight;
};
exports.isInRange = isInRange;
var getAt = function (obj, tx, ty) {
    var secx = Math.floor(tx / obj.sectionTileWidth);
    var secy = Math.floor(ty / obj.sectionTileHeight);
    var ox = tx % obj.sectionTileWidth;
    var oy = ty % obj.sectionTileHeight;
    var section = exports.getSectionAt(obj, secx, secy);
    if (!section) {
        return null;
    }
    return section.tiles[oy * obj.sectionTileWidth + ox];
};
exports.getAt = getAt;
var getSectionAt = function (obj, secx, secy) {
    if (!exports.isSectionInRange(obj, secx, secy)) {
        return null;
    }
    return obj.sections[secy * obj.sectionsWidth + secx];
};
exports.getSectionAt = getSectionAt;
var create = function (sectionsWidth, sectionsHeight) {
    var size = exports.sectionSize;
    var obj = {
        sectionsWidth: sectionsWidth,
        sectionsHeight: sectionsHeight,
        sectionTileWidth: size,
        sectionTileHeight: size,
        totalTileWidth: sectionsWidth * size,
        totalTileHeight: sectionsHeight * size,
        sections: [],
    };
    for (var iSecY = 0; iSecY < sectionsHeight; iSecY++) {
        for (var iSecX = 0; iSecX < sectionsWidth; iSecX++) {
            var section = {
                secx: iSecX,
                secy: iSecY,
                otx: iSecX * size,
                oty: iSecY * size,
                isFilled: false,
                tiles: [],
            };
            obj.sections.push(section);
            for (var iy = 0; iy < size; iy++) {
                for (var ix = 0; ix < size; ix++) {
                    var tile = {
                        tx: iSecX * size + ix,
                        ty: iSecY * size + iy,
                        ox: ix,
                        oy: iy,
                        tileIdx: 0,
                        tileIdxUp: 0,
                        color: 0,
                        rotation: 0,
                        horizSpanCount: 0,
                        vertSpanCount: 0,
                    };
                    // Checkerboard pattern
                    var mod = (iSecY + iSecX) % 2;
                    if (mod === 0) {
                        tile.tileIdx = -1;
                    }
                    section.tiles.push(tile);
                }
            }
        }
    }
    return obj;
};
exports.create = create;
function clear(obj) {
    for (var i = 0; i < obj.sections.length; i++) {
        var section = obj.sections[i];
        section.isFilled = false;
        for (var j = 0; j < section.tiles.length; j++) {
            var tile = section.tiles[j];
            tile.tileIdx = -1;
            tile.tileIdxUp = -1;
            tile.color = 0;
            tile.rotation = 0;
        }
    }
}
exports.clear = clear;
